var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.86 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e44d27;}.cls-2{fill:#ec652b;}.cls-3{fill:#ebebeb;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 3.9 44.17 21.37 50 38.96 44.17 42.86 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.43 4 38.49 4 35.21 41.2 21.38 45.78 21.43 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14.34 19.79 13.88 14.28 21.42 14.28 21.43 8.95 7.98 8.95 9.41 25.2 21.41 25.2 21.41 19.79 14.34 19.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.39 33.76 21.37 33.76 15.4 32.14 15.01 27.89 9.69 27.89 10.36 36.35 21.37 39.4 21.39 39.4 21.39 33.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "34.4 14.28 34.89 8.95 21.43 8.95 21.42 14.28 34.4 14.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "21.5 39.4 21.5 39.36 32.42 36.35 33.94 19.79 21.41 19.79 21.41 25.2 28.04 25.2 27.37 32.14 21.39 33.76 21.39 39.4 21.5 39.4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlColour);
export default __webpack_public_path__ + "static/media/HTML_colour.de86970988c82ca7502b62ad2ef05a1f.svg";
export { ForwardRef as ReactComponent };